import crud from '@/crud/index/index'
import resources from '../../resources'

import components from './components'
import computed from './computed'

export default {
  components,
  computed,
  resourcePath: '/v1/patient/settings/addresses',
  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/settings/addresses/index/resources/index.js